import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Heading } from 'styled-minimal';
import { persistor } from 'store/index';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'kinetico-app-githash';

export const ReloadWrapper = styled.div`
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
  max-width: 420px;
  width: calc(100% - 24px);

  button {
    pointer-events: all;
  }

  .buttons {
    display: flex;
    gap: 8px;
  }
`;

const getBuildHash = () => (typeof APP__GITHASH !== 'undefined' ? APP__GITHASH : '');

const Reload = () => {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const currentHash = getBuildHash();
    if (!currentHash) {
      return;
    }

    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      window.localStorage.setItem(STORAGE_KEY, currentHash);
      return;
    }

    if (stored !== currentHash) {
      setOutdated(true);
    }
  }, []);

  const handleReload = async () => {
    const currentHash = getBuildHash();

    await persistor.purge();

    window.localStorage.clear();
    window.sessionStorage.clear();
    if (currentHash) {
      window.localStorage.setItem(STORAGE_KEY, currentHash);
    }

    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
    }

    window.location.reload(true);
  };

  if (!outdated) {
    return null;
  }

  return (
    <ReloadWrapper>
      <Heading as="h6" mb={3}>
        There's a new version of this app!
      </Heading>
      <div className="buttons">
        <Button variant="dark" bordered size="sm" onClick={handleReload}>
          Reload
        </Button>
        <Button as={Link} to="/changelog" variant="primary" bordered size="sm">
          View changes
        </Button>
      </div>
    </ReloadWrapper>
  );
};

export default Reload;
